interface ErrorToastProps {
  title: string;
  message: string;
}

export const ErrorToast = ({ title, message }: ErrorToastProps) => {
  return (
    <div className='flex items-center gap-3'>
      <div className='w-16 h-16 flex justify-center items-center bg-[#FECACA] rounded-md'>
        <svg className='w-10 h-10 text-[#EF4444]' fill='none' stroke='currentColor' viewBox='0 0 24 24'>
          <path
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeWidth='2'
            d='M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z'
          />
        </svg>
      </div>
      <div>
        <h2 className='font-semibold text-primary-600'>{title}</h2>
        <p className='text-primary-600'>{message}</p>
      </div>
    </div>
  );
};
